import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ExportButton({ module, label = "Excel" }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(`/export/${module}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      const cd = res.headers["content-disposition"] || "";
      const match = cd.match(/filename="?([^"]+)"?/);
      link.setAttribute("download", match ? match[1] : `sango_${module}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Excel downloaded");
    } catch (e) {
      toast.error("Export failed");
    } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={download} disabled={busy} data-testid={`export-${module}`} className="gap-2">
      <Download className="w-4 h-4" /> {busy ? "…" : label}
    </Button>
  );
}
